import { render, staticRenderFns } from "./StateDetails.vue?vue&type=template&id=04e46fce"
import script from "./StateDetails.vue?vue&type=script&lang=ts"
export * from "./StateDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e46fce')) {
      api.createRecord('04e46fce', component.options)
    } else {
      api.reload('04e46fce', component.options)
    }
    module.hot.accept("./StateDetails.vue?vue&type=template&id=04e46fce", function () {
      api.rerender('04e46fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/state/components/StateDetails.vue"
export default component.exports